/* eslint-disable import/prefer-default-export */

export const decodeId = (id, type) => parseInt(decodeURIComponent(id).split(`gid://shopify/${type}/`)[1], 10);

export const reorderOptions = (options, sizes) => {
  const sizeOrder = sizes.toUpperCase().split(',');

  return options.sort((optionOne, optionTwo) => {
    const a = optionOne.toUpperCase();
    const b = optionTwo.toUpperCase();
    const numA = parseFloat(a);
    const numB = parseFloat(b);

    const isNumericA = !Number.isNaN(numA) && Number.isFinite(numA);
    const isNumericB = !Number.isNaN(numB) && Number.isFinite(numB);

    if (sizeOrder.includes(a) && sizeOrder.includes(b)) {
      return sizeOrder.indexOf(a) - sizeOrder.indexOf(b);
    }

    if (sizeOrder.includes(a)) return -1;
    if (sizeOrder.includes(b)) return 1;

    if (isNumericA && isNumericB) {
      return numA - numB;
    }

    return a.localeCompare(b);
  });
};

/*  eslint-disable no-useless-escape */
export const handleize = (text) => 
  text.toString().toLowerCase()
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '')            // Trim - from end of text
/* eslint-enable no-useless-escape */
